import _slicedToArray from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _regeneratorRuntime from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _defineProperty from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var TEXTURE_TYPES = {
  UBYTE_RGBA: {
    internalFormat: "RGBA",
    format: "RGBA",
    type: "UNSIGNED_BYTE"
  },
  UINT_RGBA: {
    internalFormat: "RGBA",
    format: "RGBA",
    type: "UNSIGNED_INT"
  },
  FLOAT16_RGBA: {
    internalFormat: "RGBA16F",
    format: "RGBA",
    type: "FLOAT",
    minFilter: "NEAREST"
  },
  FLOAT32_RGBA: {
    internalFormat: "RGBA32F",
    format: "RGBA",
    type: "FLOAT",
    minFilter: "NEAREST"
  },
  UBYTE_RGB: {
    internalFormat: "RGB",
    format: "RGB",
    type: "UNSIGNED_BYTE"
  },
  UINT_RGB: {
    internalFormat: "RGB",
    format: "RGB",
    type: "UNSIGNED_INT"
  },
  FLOAT16_RGB: {
    internalFormat: "RGB16F",
    format: "RGB",
    type: "FLOAT",
    minFilter: "NEAREST"
  },
  FLOAT32_RGB: {
    internalFormat: "RGB32F",
    format: "RGB",
    type: "FLOAT",
    minFilter: "NEAREST"
  },
  FLOAT16_RG: {
    internalFormat: "RG16F",
    format: "RG",
    type: "HALF_FLOAT"
  },
  LUMINANCE: {
    internalFormat: "LUMINANCE",
    format: "LUMINANCE",
    type: "UNSIGNED_BYTE"
  }
};

function createTexture(context, typeSpec, width, height) {
  var GL = context.gl;
  var targetTexture = GL.createTexture();
  GL.bindTexture(GL.TEXTURE_2D, targetTexture);
  var minFilter = typeSpec.minFilter;
  var magFilter = typeSpec.magFilter;

  if (!minFilter && !magFilter) {
    minFilter = "LINEAR";
  }

  if (minFilter && !magFilter) {
    magFilter = "NEAREST";
  }

  if (magFilter && !minFilter) {
    minFilter = magFilter;
  } // define size and format of level 0


  var level = 0;
  var internalFormat = GL[typeSpec.internalFormat];
  var border = 0;
  var format = GL[typeSpec.format];
  var type = GL[typeSpec.type];
  var data = null;
  GL.texImage2D(GL.TEXTURE_2D, level, internalFormat, width, height, border, format, type, data);
  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MIN_FILTER, GL[minFilter]);
  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MAG_FILTER, GL[magFilter]);
  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_S, GL.CLAMP_TO_EDGE);
  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_T, GL.CLAMP_TO_EDGE);
  return targetTexture;
}

function createDepthTexture(context, width, height) {
  var GL = context.gl;
  var targetTexture = GL.createTexture();
  GL.bindTexture(GL.TEXTURE_2D, targetTexture); // define size and format of level 0

  var level = 0;
  var internalFormat = GL.DEPTH_COMPONENT24;
  var border = 0;
  var format = GL.DEPTH_COMPONENT;
  var type = GL.UNSIGNED_INT;
  var data = null;
  GL.texImage2D(GL.TEXTURE_2D, level, internalFormat, width, height, border, format, type, data); // set the filtering so we don't need mips

  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MIN_FILTER, GL.NEAREST);
  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MAG_FILTER, GL.NEAREST);
  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_S, GL.CLAMP_TO_EDGE);
  GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_T, GL.CLAMP_TO_EDGE);
  return targetTexture;
}

function createFramebuffer(context, textures, depthTexture) {
  var GL = context.gl;
  var framebuffer = GL.createFramebuffer();
  GL.bindFramebuffer(GL.FRAMEBUFFER, framebuffer);
  var attachmentPoints = [];

  for (var i = 0; i < textures.length; i++) {
    var attachmentPoint = GL["COLOR_ATTACHMENT" + i];
    attachmentPoints.push(attachmentPoint);
    GL.framebufferTexture2D(GL.FRAMEBUFFER, attachmentPoint, GL.TEXTURE_2D, textures[i], 0);
  }

  if (depthTexture) {
    GL.framebufferTexture2D(GL.FRAMEBUFFER, GL.DEPTH_ATTACHMENT, GL.TEXTURE_2D, depthTexture, 0);
  }

  GL.drawBuffers(attachmentPoints);
  var status = GL.checkFramebufferStatus(GL.FRAMEBUFFER);

  if (status !== GL.FRAMEBUFFER_COMPLETE) {
    var _states;

    var states = (_states = {}, _defineProperty(_states, String(GL.FRAMEBUFFER_INCOMPLETE_ATTACHMENT), "FRAMEBUFFER_INCOMPLETE_ATTACHMENT"), _defineProperty(_states, String(GL.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT), "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT"), _defineProperty(_states, String(GL.FRAMEBUFFER_INCOMPLETE_DIMENSIONS), "FRAMEBUFFER_INCOMPLETE_DIMENSIONS"), _defineProperty(_states, String(GL.FRAMEBUFFER_UNSUPPORTED), "FRAMEBUFFER_UNSUPPORTED"), _defineProperty(_states, String(GL.FRAMEBUFFER_INCOMPLETE_MULTISAMPLE), "FRAMEBUFFER_INCOMPLETE_MULTISAMPLE"), _defineProperty(_states, String(GL.RENDERBUFFER_SAMPLES), "RENDERBUFFER_SAMPLES"), _states);
    throw new Error("Error constructing frame buffer: " + (states[String(status)] || "Unknown"));
  }

  ;
  return framebuffer;
}

var RenderDelegator =
/*#__PURE__*/
function () {
  function RenderDelegator() {
    _classCallCheck(this, RenderDelegator);

    this.subRenderers = [];
  }

  _createClass(RenderDelegator, [{
    key: "initAsync",
    value: function () {
      var _initAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _i, _Object$values, renderer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _i = 0, _Object$values = Object.values(this.allSubRenderers);

              case 1:
                if (!(_i < _Object$values.length)) {
                  _context.next = 8;
                  break;
                }

                renderer = _Object$values[_i];
                _context.next = 5;
                return renderer.initAsync();

              case 5:
                _i++;
                _context.next = 1;
                break;

              case 8:
                return _context.abrupt("return", this);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initAsync() {
        return _initAsync.apply(this, arguments);
      }

      return initAsync;
    }()
  }, {
    key: "resize",
    value: function resize() {
      this.forEachSubRenderer(function (r) {
        return r.resize();
      });
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.forEachSubRenderer(function (r) {
        return r.destroy();
      });
      return this;
    }
  }, {
    key: "addSubRenderer",
    value: function addSubRenderer(name, renderer) {
      this.removeSubRenderer(name);
      this.subRenderers.push({
        name: name,
        renderer: renderer
      });
      return this;
    }
  }, {
    key: "removeSubRenderer",
    value: function removeSubRenderer(name) {
      this.subRenderers = this.subRenderers.filter(function (r) {
        return r.name !== name;
      });
      return this;
    }
  }, {
    key: "getSubRenderer",
    value: function getSubRenderer(name) {
      return this.subRenderers.filter(function (r) {
        return r.name === name;
      })[0].renderer;
    }
  }, {
    key: "forEachSubRenderer",
    value: function forEachSubRenderer(callback) {
      for (var _i2 = 0, _Object$values2 = Object.values(this.allSubRenderers); _i2 < _Object$values2.length; _i2++) {
        var renderer = _Object$values2[_i2];
        callback(renderer);
      }

      return this;
    }
  }, {
    key: "query",
    value: function query(_query) {
      for (var _i3 = 0, _Object$values3 = Object.values(this.allSubRenderers); _i3 < _Object$values3.length; _i3++) {
        var renderer = _Object$values3[_i3];
        var answer = renderer.query(_query);

        if (answer !== undefined) {
          return answer;
        }
      }
    }
  }, {
    key: "render",
    value: function render(frameInfo, mountBufferFunc, properties) {
      if (frameInfo.frameId !== this.lastFrameId) {
        this.lastFrameId = frameInfo.frameId;
        this.customRender(frameInfo, mountBufferFunc, properties);
      }

      return this;
    } // Default implementation just delegates to sub renderers

  }, {
    key: "customRender",
    value: function customRender(frameInfo, mountBufferFunc, properties) {
      this.internalRenderSubsToBuffer(frameInfo, mountBufferFunc, properties);
      return this;
    }
  }, {
    key: "internalRenderSubsToBuffer",
    value: function internalRenderSubsToBuffer(frameInfo, mountBufferFunc, properties) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.subRenderers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var sub = _step.value;
          mountBufferFunc();
          var inheritedProperties = {};

          for (var _i4 = 0, _Object$keys = Object.keys(properties); _i4 < _Object$keys.length; _i4++) {
            var key = _Object$keys[_i4];
            inheritedProperties[key] = Object.create(properties[key]);
          }

          sub.renderer.render(frameInfo, mountBufferFunc, inheritedProperties);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this;
    }
  }, {
    key: "allSubRenderers",
    get: function get() {
      var renderersObject = {};
      this.subRenderers.forEach(function (r) {
        return renderersObject[r.name] = r.renderer;
      });
      return renderersObject;
    }
  }]);

  return RenderDelegator;
}();

var Renderer =
/*#__PURE__*/
function (_RenderDelegator) {
  _inherits(Renderer, _RenderDelegator);

  function Renderer(context) {
    var _this;

    _classCallCheck(this, Renderer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Renderer).call(this));
    _this.context = context;
    _this.offscreens = [];
    _this.queryTargets = [];
    _this.textures = [];
    return _this;
  }

  _createClass(Renderer, [{
    key: "initAsync",
    value: function () {
      var _initAsync2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _i5, _Object$values4, offscreen;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _get(_getPrototypeOf(Renderer.prototype), "initAsync", this).call(this);

              case 2:
                _i5 = 0, _Object$values4 = Object.values(this.allOffscreens);

              case 3:
                if (!(_i5 < _Object$values4.length)) {
                  _context2.next = 10;
                  break;
                }

                offscreen = _Object$values4[_i5];
                _context2.next = 7;
                return offscreen.initAsync();

              case 7:
                _i5++;
                _context2.next = 3;
                break;

              case 10:
                if (this.asyncInitialized) {
                  _context2.next = 15;
                  break;
                }

                if (!this.customInitAsync) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return this.customInitAsync();

              case 14:
                this.asyncInitialized = true;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initAsync() {
        return _initAsync2.apply(this, arguments);
      }

      return initAsync;
    }()
  }, {
    key: "resize",
    value: function resize() {
      _get(_getPrototypeOf(Renderer.prototype), "resize", this).call(this);

      this.forEachOffscreen(function (s) {
        return s.resize();
      });
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Renderer.prototype), "destroy", this).call(this);

      this.forEachOffscreen(function (s) {
        return s.destroy();
      });
      return this;
    }
  }, {
    key: "addOffscreen",
    value: function addOffscreen(name, offscreen) {
      this.removeOffscreen(name);
      this.offscreens.push({
        name: name,
        offscreen: offscreen
      });
      return this;
    }
  }, {
    key: "removeOffscreen",
    value: function removeOffscreen(name) {
      this.offscreens = this.offscreens.filter(function (s) {
        return s.name !== name;
      });
      return this;
    }
  }, {
    key: "getOffscreen",
    value: function getOffscreen(name) {
      return (this.offscreens.filter(function (s) {
        return s.name === name;
      })[0] || {}).offscreen;
    }
  }, {
    key: "forEachOffscreen",
    value: function forEachOffscreen(callback) {
      for (var _i6 = 0, _Object$values5 = Object.values(this.allOffscreens); _i6 < _Object$values5.length; _i6++) {
        var offscreen = _Object$values5[_i6];
        callback(offscreen);
      }

      return this;
    }
  }, {
    key: "addQueryTarget",
    value: function addQueryTarget(name, target) {
      this.removeQueryTarget(name);
      this.queryTargets.push({
        name: name,
        target: target
      });
      return this;
    }
  }, {
    key: "removeQueryTarget",
    value: function removeQueryTarget(name) {
      this.queryTargets = this.queryTargets.filter(function (s) {
        return s.name !== name;
      });
      return this;
    }
  }, {
    key: "getQueryTarget",
    value: function getQueryTarget(name) {
      return (this.queryTargets.filter(function (s) {
        return s.name === name;
      })[0] || {}).target;
    }
  }, {
    key: "query",
    value: function query(_query2) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.queryTargets.map(function (t) {
          return t.target;
        })[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var queryTarget = _step2.value;
          var answer = queryTarget.query(_query2);

          if (answer !== undefined) {
            return answer;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return _get(_getPrototypeOf(Renderer.prototype), "query", this).call(this, _query2);
    }
  }, {
    key: "allOffscreens",
    get: function get() {
      var offscreensObject = {};
      this.offscreens.forEach(function (s) {
        return offscreensObject[s.name] = s.offscreen;
      });
      return offscreensObject;
    }
  }]);

  return Renderer;
}(RenderDelegator);

var Screen =
/*#__PURE__*/
function (_RenderDelegator2) {
  _inherits(Screen, _RenderDelegator2);

  function Screen(context, clearSpec) {
    var _this2;

    _classCallCheck(this, Screen);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Screen).call(this));
    _this2.context = context;
    _this2.clearSpec = clearSpec;
    return _this2;
  }

  _createClass(Screen, [{
    key: "render",
    value: function render(frameInfo, properties) {
      if (frameInfo.frameId !== this.lastFrameId) {
        this.lastFrameId = frameInfo.frameId;

        if (this.clearSpec) {
          var _this$clearSpec = _slicedToArray(this.clearSpec, 5),
              red = _this$clearSpec[0],
              green = _this$clearSpec[1],
              blue = _this$clearSpec[2],
              alpha = _this$clearSpec[3],
              depth = _this$clearSpec[4];

          this.clearTo(red, green, blue, alpha, depth);
        }

        this.internalRenderSubsToBuffer(frameInfo, this.mountBufferFunc, properties);
      }

      return this;
    }
  }, {
    key: "clearTo",
    value: function clearTo(red, green, blue, alpha, depth) {
      var GL = this.context.gl;
      var clearBits = 0;

      if (red !== undefined || green !== undefined || blue !== undefined || alpha !== undefined) {
        GL.clearColor(red, green, blue, alpha);
        clearBits = clearBits | GL.COLOR_BUFFER_BIT;
      }

      if (depth !== undefined) {
        GL.clearDepth(depth);
        clearBits = clearBits | GL.DEPTH_BUFFER_BIT;
      }

      this.mountBufferFunc();
      GL.clear(clearBits);
    }
  }, {
    key: "mountBufferFunc",
    get: function get() {
      var GL = this.context.gl;
      return function () {
        GL.bindFramebuffer(GL.FRAMEBUFFER, null);
        GL.viewport(0, 0, GL.drawingBufferWidth, GL.drawingBufferHeight);
      };
    }
  }]);

  return Screen;
}(RenderDelegator);

var Offscreen =
/*#__PURE__*/
function (_Screen) {
  _inherits(Offscreen, _Screen);

  function Offscreen(context) {
    var _this3;

    var colorAttachments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [TEXTURE_TYPES.UBYTE_RGBA];
    var includeDepthBuffer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var clearSpec = arguments.length > 3 ? arguments[3] : undefined;
    var width = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var height = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

    _classCallCheck(this, Offscreen);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Offscreen).call(this, context, clearSpec));
    _this3.width = width;
    _this3.height = height;
    _this3.colorAttachments = colorAttachments;
    _this3.includeDepthBuffer = includeDepthBuffer;

    _this3.internalInitFramebuffer();

    return _this3;
  }

  _createClass(Offscreen, [{
    key: "resize",
    value: function resize() {
      _get(_getPrototypeOf(Offscreen.prototype), "resize", this).call(this);

      if (this.width === 0 || this.height === 0) {
        this.internalDestroyFramebuffer();
        this.internalInitFramebuffer();
      }

      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Offscreen.prototype), "destroy", this).call(this);

      this.internalDestroyFramebuffer();
      return this;
    }
  }, {
    key: "render",
    value: function render(frameInfo, properties) {
      _get(_getPrototypeOf(Offscreen.prototype), "render", this).call(this, frameInfo, properties);

      return this.getTextures();
    }
  }, {
    key: "getTextures",
    value: function getTextures() {
      return {
        colors: this.framebufferTextures,
        depth: this.includeDepthBuffer ? this.depthBufferTexture : undefined
      };
    }
  }, {
    key: "dismountFrameBuffer",
    value: function dismountFrameBuffer() {
      var GL = this.context.gl;
      GL.bindFramebuffer(GL.FRAMEBUFFER, null);
    }
  }, {
    key: "blitToCurrentFramebuffer",
    value: function blitToCurrentFramebuffer(maskBits) {
      var GL = this.context.gl;
      GL.bindFramebuffer(GL.READ_FRAMEBUFFER, this.framebuffer);
      GL.blitFramebuffer(0, 0, this.width || GL.drawingBufferWidth, this.height || GL.drawingBufferHeight, 0, 0, this.width || GL.drawingBufferWidth, this.height || GL.drawingBufferHeight, maskBits, GL.NEAREST);
      GL.bindFramebuffer(GL.READ_FRAMEBUFFER, null);
    }
  }, {
    key: "internalInitFramebuffer",
    value: function internalInitFramebuffer() {
      var GL = this.context.gl;
      var width = this.width || GL.drawingBufferWidth;
      var height = this.height || GL.drawingBufferHeight;
      this.framebufferTextures = []; // Maybe this one needs names?

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.colorAttachments[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var attachment = _step3.value;
          this.framebufferTextures.push(createTexture(this.context, attachment, width, height));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (this.includeDepthBuffer) {
        this.depthBufferTexture = createDepthTexture(this.context, width, height);
      }

      this.framebuffer = createFramebuffer(this.context, this.framebufferTextures, this.depthBufferTexture);
      GL.bindTexture(GL.TEXTURE_2D, null);
      GL.bindFramebuffer(GL.FRAMEBUFFER, null);
    }
  }, {
    key: "internalDestroyFramebuffer",
    value: function internalDestroyFramebuffer() {
      var GL = this.context.gl;
      GL.deleteFramebuffer(this.framebuffer);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.framebufferTextures[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var texture = _step4.value;
          GL.deleteTexture(texture);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (this.includeDepthBuffer) {
        GL.deleteTexture(this.depthBufferTexture);
      }

      delete this.framebufferTextures;
      delete this.depthBufferTexture;
      delete this.framebuffers;
    }
  }, {
    key: "mountBufferFunc",
    get: function get() {
      var _this4 = this;

      var GL = this.context.gl;
      return function () {
        GL.bindFramebuffer(GL.FRAMEBUFFER, _this4.framebuffer);
        GL.viewport(0, 0, _this4.width || GL.drawingBufferWidth, _this4.height || GL.drawingBufferHeight);
      };
    }
  }]);

  return Offscreen;
}(Screen);

export { Renderer, Screen, Offscreen, TEXTURE_TYPES };